import React, { useEffect, useState } from "react";
import BaseURL from "../../../assets/utils/baseUrl";
import MUIDataTable from "mui-datatables";
import { Button, Footer, HeaderAdmin } from "../../../components";
import { TextField } from "@material-ui/core";
import { Loader } from "../../../assets";

function KelolaBeritaVideo({ setToken }) {
  const [berita, setBerita] = useState([]);
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(true);
  const [popUp, setPopUp] = useState(false);
  const [success, setSuccess] = useState(true);
  const [load, setLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [alertJudul, setAlertJudul] = useState(false);
  const [alertIdVideo, setAlertIdVideo] = useState(false);
  const [alertThumbnail, setAlertThumbnail] = useState(false);
  const [formData, setFormData] = useState({
    judul: "",
    id_video: "",
    thumbnail: "",
    created_at: "",
  });
  const [id, setId] = useState("");

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      await fetch(BaseURL + "index.php/api/Berita_video")
        .then((res) => res.json())
        .then((data) => {
          if (data.data) {
            let tableData = [];
            for (let i = 0; i < data.data.length; i++) {
              tableData.push({
                judul: data.data[i].judul,
                id_video: data.data[i].id_video,
                thumbnail: data.data[i].thumbnail,
                tanggal_post: data.data[i].created_at,
                user: data.data[i].nama_user,
                opsi: data.data[i].id_berita_video,
              });
            }
            setBerita(tableData);
          }
          setLoading(false);
        });
    };
    getData();
  }, [load]);

  const columns = [
    {
      name: "judul",
      label: "Judul",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "id_video",
      label: "Id Video",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "thumbnail",
      label: "Thumbnail",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div style={{ flex: 1 }}>
              <a href={value} target="_blank" rel="noopener noreferrer">
                {value}
              </a>
            </div>
          );
        },
      },
    },
    {
      name: "tanggal_post",
      label: "Tanggal Post",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return <div style={{ width: 100 }}>{value}</div>;
        },
      },
    },
    {
      name: "user",
      label: "Admin",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "opsi",
      label: "Opsi",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div
                className="tooltip btn-hapus-row"
                onClick={() => hapus(value)}
              >
                <i className="fas fa-trash-alt"></i>
                <span className="tooltiptext">Hapus</span>
              </div>
              <div
                className="tooltip btn-edit-row"
                onClick={() => {
                  setUpdateModal(true);
                  openUpdateModal(value);
                }}
              >
                <i className="fas fa-edit"></i>
                <span className="tooltiptext">Update</span>
              </div>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    sort: true,
    filter: false,
    download: false,
    print: false,
    selectableRows: false,
  };

  let tablesData = [];

  if (berita) {
    for (let i = 0; i < berita.length; i++) {
      tablesData.push({
        judul: berita[i].judul,
        id_video: berita[i].id_video,
        thumbnail: berita[i].thumbnail,
        tanggal_post: berita[i].created_at,
        user: berita[i].nama_user,
        opsi: berita[i].id_berita_video,
      });
    }
  }

  const tambah = () => {
    if (formData.judul == "") {
      setAlertJudul(true);
    } else {
      setAlertJudul(false);
    }

    if (formData.id_video == "") {
      setAlertIdVideo(true);
    } else {
      setAlertIdVideo(false);
    }

    if (formData.thumbnail == "") {
      setAlertThumbnail(true);
    } else {
      setAlertThumbnail(false);
    }

    if (
      formData.judul !== "" &&
      formData.id_video !== "" &&
      formData.thumbnail !== ""
    ) {
      const data = new FormData();
      let today = new Date();
      let date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      data.append("request", "post");
      data.append("judul", formData.judul);
      data.append("id_video", formData.id_video);
      data.append("thumbnail", formData.thumbnail);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_at", date);

      try {
        fetch(BaseURL + "index.php/api/berita_video", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              judul: "",
              id_video: "",
              thumbnail: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  const hapus = (id) => {
    var encodedKey = encodeURIComponent("id_berita_video");
    var encodedValue = encodeURIComponent(id);
    const formBody = [encodedKey + "=" + encodedValue];
    try {
      fetch(BaseURL + "index.php/api/Berita_video", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formBody,
      })
        .then((response) => response.json())
        .then((data) => {
          setLoad(!load);
          if (data.status) {
            setSuccess(true);
          } else {
            setSuccess(false);
          }
          setPopUp(true);
        })
        .catch((error) => console.log("Gagal: ", error));
    } catch (error) {
      alert("Terjadi kesalahan pada sistem");
      console.log(error);
    }
  };

  const openUpdateModal = (id) => {
    const getDataUpdate = async () => {
      await fetch(BaseURL + "index.php/api/berita_video?id=" + id)
        .then((res) => res.json())
        .then((data) => {
          setFormData({
            ...formData,
            judul: data.data[0].judul,
            id_video: data.data[0].id_video,
            thumbnail: data.data[0].thumbnail,
          });
          setId(id);
          setModal(true);
        });
    };
    getDataUpdate();
  };

  const update = () => {
    if (formData.judul == "") {
      setAlertJudul(true);
    } else {
      setAlertJudul(false);
    }

    if (formData.id_video == "") {
      setAlertIdVideo(true);
    } else {
      setAlertIdVideo(false);
    }

    if (formData.thumbnail == "") {
      setAlertThumbnail(true);
    } else {
      setAlertThumbnail(false);
    }

    if (
      formData.judul !== "" &&
      formData.id_video !== "" &&
      formData.thumbnail !== ""
    ) {
      const data = new FormData();
      let today = new Date();
      let date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      data.append("request", "put");
      data.append("id_berita_video", id);
      data.append("judul", formData.judul);
      data.append("id_video", formData.id_video);
      data.append("thumbnail", formData.thumbnail);
      data.append("id_user", localStorage.getItem("id"));
      data.append("updated_at", date);

      try {
        fetch(BaseURL + "index.php/api/berita_video", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              judul: "",
              id_video: "",
              thumbnail: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  return (
    <div className="page">
      <HeaderAdmin title="Kelola Berita Video" setToken={(e) => setToken(e)} />
      <div className="main-admin">
        <div className="container-admin">
          <div style={{ height: 50 }} />
          <Button
            title="Tambah Post"
            type="primary"
            onClick={() => {
              setUpdateModal(false);
              setModal(true);
            }}
          />
          <div style={{ height: 10 }} />
          {loading ? (
            <div className="loader">
              <img src={Loader}></img>
            </div>
          ) : (
            <MUIDataTable
              title={"Daftar Berita Video"}
              data={berita}
              columns={columns}
              options={options}
              download={false}
              className="table"
            />
          )}
        </div>
      </div>

      <Footer />

      {/* modal */}
      <div className={modal ? "darker-bg-admin" : "darker-bg-admin hide"}>
        {/* form */}
        <div className="modal-admin">
          <div className="form-admin">
            <TextField
              id="judul"
              label="Judul"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) =>
                setFormData({ ...formData, judul: e.target.value })
              }
              value={formData.judul}
            />
            {alertJudul && (
              <div className="danger-alert">Judul tidak boleh kosong</div>
            )}

            <TextField
              id="id_video"
              label="Id Video"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) =>
                setFormData({ ...formData, id_video: e.target.value })
              }
              value={formData.id_video}
            />
            {alertIdVideo && (
              <div className="danger-alert">Id Video tidak boleh kosong</div>
            )}

            <TextField
              id="thumbnail"
              label="Thumbnail"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) =>
                setFormData({ ...formData, thumbnail: e.target.value })
              }
              value={formData.thumbnail}
            />
            {alertThumbnail && (
              <div className="danger-alert">Thumbnail tidak boleh kosong</div>
            )}
          </div>

          <div style={{ height: 30 }}></div>

          <div className="form-option">
            <Button
              title={updateModal ? "Update" : "Tambah"}
              type="primary"
              onClick={() => {
                if (updateModal) {
                  update();
                } else {
                  tambah();
                }
              }}
            />
            <div style={{ width: 10 }}></div>
            <Button
              title="Batal"
              type="danger"
              onClick={() => {
                setModal(false);
                setUpdateModal(false);
                setFormData({
                  judul: "",
                  id_video: "",
                  thumbnail: "",
                });
                setAlertJudul(false);
                setAlertIdVideo(false);
                setAlertThumbnail(false);
              }}
            />
          </div>
        </div>
      </div>

      {/* message pop up */}
      <div className={popUp ? "darker-bg-admin" : "darker-bg-admin hide"}>
        <div className="pop-up-admin">
          <i
            className={
              success
                ? "fas fa-check-circle pop-up-logo"
                : "fas fa-times-circle pop-up-logo failed-pop-up"
            }
          ></i>
          {success ? (
            <p>Berhasil</p>
          ) : (
            <p className={success ? "" : "failed-pop-up"}>Gagal</p>
          )}
          <div style={{ height: 20 }}></div>
          <Button
            title="Tutup"
            type="primary"
            onClick={() => {
              setAlertJudul(false);
              setAlertIdVideo(false);
              setAlertThumbnail(false);
              setPopUp(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KelolaBeritaVideo;
